// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderLinesListStyles } from "@west/Overrides/Components/CartLinesList";
import EditSquare from "@west/XDL/Icons/EditSquare";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productCountContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 36px;
        margin-bottom: 18px;
        ${xScreen("lte", "md")} {
            padding-bottom: 18px;
            margin-bottom: 0;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

orderLinesListStyles.productCountText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

orderLinesListStyles.editCartLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 14px;
        `,
    },
    icon: {
        iconProps: {
            src: EditSquare,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
        position: "left",
    },
};
